module.exports = __webpack_public_path__ + "static/media/img012.0327c234.jpg";